module.exports = __webpack_public_path__ + "static/financial_advisor_01-b614e010914e540edba11f26ff5b8d72.svg";